import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BackButtonBlockGuard implements CanDeactivate<unknown> {

  constructor(private router: Router, private location: Location) {}

  canDeactivate(
    component: unknown,
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      
      // Define the specific page(s) where you want to block the back button
      const blockedRoutes = [ '/visitor-thank-you'];

      if (blockedRoutes.includes(state.url)) {
        // If the user is on a blocked route, we prevent going back by replacing the current URL
        this.location.replaceState(state.url);  // Prevent navigation back
        return false;  // Cancel the navigation
      }

      // Allow navigation if not a blocked route
    return true;
  }
  
}
